<template>
<div :id="modalid" class="modal fade"> 
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" aria-hidden="true" @click="closeModal">&times;</button>
                <h4 class="modal-title" v-if="title == null">{{$t('misc.changeValue', {value:$t(scope+'.values.'+id)})}}</h4>
                <h4 class="modal-title" v-else>{{title}}</h4>
            </div>
	            <div class="modal-body">
	                <date-input :value="value" :id="id" v-if="datatype == 'date'" /> 
	                <text-input :value="value" :id="id" v-else-if="datatype == 'text'" />
	                <checkbox-input :value="value" :id="id" v-else-if="datatype == 'boolean'" />
	                <dropdown-input :get="get" :value="value" :data="dataSelect" :id="id" v-else-if="datatype == 'select'" />
	                <dropdown-input-scope :get="get" :value="value" :id="id" :scope="scopeSelect" v-else-if="datatype == 'selectscope'" />
	                <password-input :value="value" :id="id" v-else-if="datatype == 'password'" />
	                <datetime-input :value="value" :id="id" v-else-if="datatype == 'datetime'" />
	                <big-text-input :value="value" :id="id" v-else-if="datatype == 'bigtext'" />
	                <div class="hidden error bg-danger" style="margin-top:10px; padding:10px" />
	            </div>
	            <div class="modal-footer">
	                <span class="wait hidden pull-left">{{$t('misc.wait')}} <i class="fa fa-refresh fa-spin" /></span>
	                <button type="button" class="btn btn-default" @click="closeModal">{{$t('misc.cancel')}}</button>
	                <button type="button" class="btn button_tiefox_dark" @click="$emit('change-element')">{{$t('misc.send')}}</button>
	            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
  name: "ModalInput",
  data() {
    return {};
  },
  props: ["modalid", "value", "datatype", "dataSelect", "id", "get", "scope", "title", "scopeSelect"],
  methods: {
	  closeModal(){
		  $('#'+this.modalid).modal('hide');
		  this.$emit('close-modal');
	  }
  }
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/input/ModalInput.vue